import { render, staticRenderFns } from "./assignmentCandidate.vue?vue&type=template&id=197ae632&scoped=true&"
import script from "./assignmentCandidate.vue?vue&type=script&lang=js&"
export * from "./assignmentCandidate.vue?vue&type=script&lang=js&"
import style0 from "./assignmentCandidate.vue?vue&type=style&index=0&id=197ae632&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197ae632",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('197ae632')) {
      api.createRecord('197ae632', component.options)
    } else {
      api.reload('197ae632', component.options)
    }
    module.hot.accept("./assignmentCandidate.vue?vue&type=template&id=197ae632&scoped=true&", function () {
      api.rerender('197ae632', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/tracking/partials/assignmentCandidate.vue"
export default component.exports